import { useNavigate } from "react-router-dom";
import { Button, Typography } from "../../components/common";

const NotFoundCourse: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <Typography variant="h1" weight="bold" >404</Typography>
      <Typography variant="h2" weight="medium" className="mt-4">
        Oops! We couldn't find that course...
      </Typography>
      <Typography variant="p" className="mt-2">
        The course you're looking for doesn't exist.
      </Typography>
      <Button
        onClick={() => navigate("/")}
        variant="filled"
        size="large"
      >
        Go Home
      </Button>
    </div>
  );
};

export default NotFoundCourse;
